/**
 * @packageDocumentation
 * @module StockChartModule
 */
declare var require: any;
import { Component, OnInit, Input } from '@angular/core';
// HighChart Dependencies
import * as Highcharts from 'highcharts/highstock';
import StockModule from 'highcharts/modules/stock';
import ExportingModule from 'highcharts/modules/exporting';
import * as HC_customEvents from 'highcharts-custom-events';
import { StockChartService } from '../stock-chart.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { isEmptyObject, isEmptyArray } from '../stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';

const HIndicatorsAll = require('highcharts/indicators/indicators');
const HDragPanes = require('highcharts/modules/drag-panes');
const HAnnotationsAdvanced = require('highcharts/modules/annotations-advanced');
const HPriceIndicator = require('highcharts/modules/price-indicator');
const HFullScreen = require('highcharts/modules/full-screen');
const HStockTools = require('highcharts/modules/stock-tools');
import HC_more from 'highcharts/highcharts-more';

HC_more(Highcharts);
HIndicatorsAll(Highcharts);
HDragPanes(Highcharts);
HAnnotationsAdvanced(Highcharts);
HPriceIndicator(Highcharts);
HFullScreen(Highcharts);
HStockTools(Highcharts);
// HC_customEvents(Highcharts);

StockModule(Highcharts);
ExportingModule(Highcharts);


@Component({
  selector: 'app-stock-chart-renderer',
  templateUrl: './stock-chart-renderer.component.html',
  styleUrls: ['./stock-chart-renderer.component.scss']
})
export class StockChartRendererComponent implements OnInit {
  /**
   * Stock Chart Id
   */
  @Input() chartId: string;
  stockChartRenderConfig: any;
  updateChart = false;
  showChart = false;
  Highcharts: typeof Highcharts = Highcharts;
  isDataPresent: boolean = false;

  constructor(
    private stockChartService: StockChartService,
  ) { }
  /**
   * Angular On Init
   * will have a subscription to the config subjects
   */
  ngOnInit() {
    this.stockChartService.stockCartConfigSubjects[this.chartId].subscribe( data => {
      if (isEmptyObject(data) || isEmptyArray(data.yAxis)) {
        this.showChart = false;
      } else {
        this.isDataPresent = this.stockChartService.isDataPresentInStockChart(data.series);
        this.stockChartRenderConfig = data;
        this.updateChart = false;
        this.showChart = false;
        setTimeout(() => {
          this.showChart = true;
          this.updateChart = true;
        }, 100);
      }
    });
  }

  initChart(event) {
  }

}
